module.exports = __webpack_public_path__ + "static/media/collection.6aa46cd4.jpeg";